import { styled } from "@mui/material/styles"
import { Link } from "react-router-dom"

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.grey[800],
  fontWeight: 300,
  maxWidth: "100%"
}))
